import { Component, OnInit, OnDestroy } from "@angular/core"
import { Store, Action } from "@ngrx/store"
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state"
import { WorkshopAbsence } from "@models/workshop-absence";
import { BookingsStore } from "@store/bookings";
import { MatrixClassesStore } from "@store/matrix-classes";
import { WorkshopEffects } from "@reducers/effects/workshop";
import { Contact } from "@models/contact";
import { Booking } from "@models/booking";
import { AffectedBookingsParams } from "@services/booking";
import { Subscription } from "rxjs/Subscription";
import { ModalService } from "@services/modal";
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer"
import * as moment from "moment";
import {
  FETCH_AFFECTED_BOOKINGS,
  FETCH_REPLACEMENT_TUTORS
} from "@reducers/bookings";
import {
  CREATE_WORKSHOP_ABSENCE,
  ADD_WORKSHOP_ABSENCE
} from "@reducers/workshops";
import { Subject } from "rxjs/Subject";

@Component({
  selector: 'workshop-absence-form',
  templateUrl: './workshop-absence-form.pug',
})
export class WorkshopAbsenceFormComponent implements OnInit, OnDestroy {


  public wa: WorkshopAbsence
  public replacementTutors: Contact[] = []
  public affectedBookings: Booking[] = []

  public dateTimeSubject$: Subject<WorkshopAbsence> = new Subject<WorkshopAbsence>()
  public dateTimeSubscription: Subscription 

  public replacementTutorSearchStr: string
  public replacementTutorCompleter: CompleterData
  
  public isEditing: boolean
  public bookingsSubscription: Subscription 


  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private actions: Actions,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.bookingsSubscription =
      this.store.select("bookingsReducer").subscribe((s: BookingsStore) => {
        this.wa                 = s.editableWorkshopAbsence
        this.affectedBookings   = s.affectedBookings
        this.replacementTutors  = s.replacementTutors
        this.populateReplacementTutorAutocompleter()
      })

    if (!this.isEditing) {
      this.setSensibleDefaultDateTimes()
    }

    this.setupSubjectForOverlappingBookings()
    this.refreshAffectedBookings(this.wa)
    this.fetchReplacementTutors()
  }

  fetchReplacementTutors() {
    this.store.dispatch({ type: FETCH_REPLACEMENT_TUTORS })
  }

  populateReplacementTutorAutocompleter() {
    this.replacementTutorCompleter =
      this.completerService.local(this.replacementTutors, "fullName", "fullName")
  }

  setSensibleDefaultDateTimes() {
    this.wa.startDateTime  = moment(new Date()).toDate()
    this.wa.endDateTime    = moment(new Date()).add(1, "days").toDate()
  }
  
  changedStartDateTime(inputVal: string) {
    const newDate = new Date(inputVal)
    if (!isNaN(newDate.getTime())) {
      this.wa.startDateTime = newDate
      this.dateTimeSubject$.next(this.wa)
    }
  }

  changedEndDateTime(inputVal: string) {
    const newDate = new Date(inputVal)
    if (!isNaN(newDate.getTime())) {
      this.wa.endDateTime = newDate
      this.dateTimeSubject$.next(this.wa)
    }
  }

  clickedCreate() {
    this.actions
      .ofType(ADD_WORKSHOP_ABSENCE)
      .take(1)
      .subscribe(() => this.modalService.closeModal())

    this.store.dispatch({ type: CREATE_WORKSHOP_ABSENCE, payload: this.wa })
  }

  selectedReplacementTutor(e: CompleterItem) {
    if (e && e.originalObject) {
      this.wa.replacementTutor    = (e.originalObject as Contact)
      this.wa.replacementTutorId  = (e.originalObject as Contact).id
    }
    else {
      this.wa.replacementTutor = null
      this.wa.replacementTutorId = null
    }
  }

  setupSubjectForOverlappingBookings() {
    this.dateTimeSubscription = this.dateTimeSubject$
      .debounceTime(1000)
      .subscribe((wa: WorkshopAbsence) => {
        this.refreshAffectedBookings(wa)
      })
  }

  refreshAffectedBookings(wa: WorkshopAbsence) {
    if (!wa.startDateTime || !wa.endDateTime) { return }

    const params: AffectedBookingsParams = {
      startDateTime: wa.startDateTime,
      endDateTime: wa.endDateTime,
      tutorAllocationId: wa.contact.tutorAllocationId,
    }

    this.store.dispatch({ type: FETCH_AFFECTED_BOOKINGS, payload: params })
  }

  ngOnDestroy() {
    this.bookingsSubscription.unsubscribe()
    this.dateTimeSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/workshop-absence-form.ts